import "./Team.scss";
import { useState, Fragment } from "react";
import TeamDetail from "./teamDetail/TeamDetail";
import { motion } from "framer-motion";
import { baseUrl } from "../../../utils/apiData";

const Team = ({ tag, title, teamData }) => {
  const [slide, setSlide] = useState(null);
  const [isDetail, setIsDetail] = useState(false);
  return (
    <Fragment>
      <section className="team p_b p_t">
        <div className="content_wrap">
          <div className="title_wrap">
           
            <h3  className="gold">
              {title
                ?.split("")
                .map((char, k) => (
                  <motion.span
                    initial={{ translateX: 24, opacity: 0 }}
                    whileInView={{ translateX: 0, opacity: 1 }}
                    transition={{
                      duration: 0.4,
                      ease: "easeInOut",
                      delay: 0.04 * k,
                    }}
                    key={k}
                  >
                    {char}
                  </motion.span>
                ))
                .concat("")}
            </h3>
          </div>
          <div className="team_grid">
            {teamData?.map((data, k) => {
              return (
                <div
                  className="team_card"
                  onClick={() => {
                    setSlide(k);
                    setIsDetail(true);
                  }}
                  key={data?._id}
                >
                  <div className="img_wrap">
                    <img src={`${baseUrl}/${data?.image}`} alt="Profile" />
                  </div>
                  <p className="name gold">{data?.name}</p>
                  <p className="post gold">{data?.proffession}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <TeamDetail
        slide={slide}
        setSlide={setSlide}
        isDetail={isDetail}
        setIsDetail={setIsDetail}
        dataList={teamData}
      />
    </Fragment>
  );
};

export default Team;
